import { useMemo } from 'react';
import { identity } from 'ramda';

export const useFields = ({ t, balance, amounts }) => {
    return useMemo(() => {
        const validations = amounts.map(amount => {
            const { fromAmount: min, toAmount: max } = amount;

            return {
                min,
                max,
                type: 'range',
                message: `${t('tooltip.buyInBetween')} ${min}-${max}`
            };
        });

        return [
            {
                name: 'amount',
                baseType: 'text',
                validation: true,
                validationRules: [
                    {
                        type: 'required',
                        message: 'playtech.mobile.system.tooltip.required'
                    },
                    {
                        type: 'amount',
                        message: 'playtech.mobile.system.tooltip.amount'
                    },
                    {
                        type: 'range',
                        min: 0,
                        max: balance,
                        message: 'playtech.mobile.system.user.tooltip.bonusMinAmount'
                    },
                    ...validations
                ]
            },
            {
                name: 'terms',
                baseType: 'text',
                validation: true,
                validationRules: [
                    {
                        type: 'required',
                        predicate: identity,
                        message: 'playtech.mobile.system.user.tooltip.terms.required'
                    }
                ]
            }
        ];
    }, [t, amounts, balance]);
};
